import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form,
} from 'react-bootstrap';
import {appConfig} from '../../config';
import './Orders.css';

import ReactPaginate from 'react-paginate';
import Switch from 'react-switch';
var dateFormat = require('dateformat');

class ViewOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        // page: 0,
        // perPage: 10,
        // qntty: null,
        // avlble: null
        // id: this.props.ordersToShow ? this.props.ordersToShow.id : null
      },
      //   qty: 0
    };
    // console.log("!!!!!!!!!!value!!1", this.state);

    // this.add = this.add.bind(this);
    // this.handleChange = this.handleChange.bind(this);
  }

  //   handleEditItemDetails = item => {
  //     this.setState({
  //       showItemDetailsEditModel: true,
  //       ItemDetailsdtList: item
  //     });
  //   };
  //   closeEditModel = () => {
  //     this.setState({
  //       showItemDetailsEditModel: false
  //     });
  //   };
  handlePageClick = e => {
    const selectedPage = e.selected;
    this.props.OrdersViewpageSelected({pages: selectedPage + 1});
    this.setState({page: selectedPage});
    console.log('!!!!!!!!!!OrdersViewpageSelected!!!!!!!!!!!!!!!!!!!1');
  };

  resetPage = () => {
    this.setState({page: 0});
  };

  //   handleChange = (event, index) => {
  //     this.props.chemistOrderDtls[index].avlble = event.target.value;
  //     console.log("index:", event.target.value);
  //   };

  //   add = (index, item) => {
  //     this.setState({ qty: item.qntty });

  //     this.props.chemistOrderDtls[index].qntty += 1;
  //     console.log("index:", this.props.chemistOrderDtls[index].qntty);
  //   };

  //   decrement = (index, item) => {
  //     this.setState({ qty: item.qntty });

  //     if (this.props.chemistOrderDtls[index].qntty - 1 < 1) {
  //     } else {
  //       this.props.chemistOrderDtls[index].qntty -= 1;
  //     }
  //   };
  //   Submit = () => {
  //     this.setState({ value: this.props.chemistOrderDtls.id });

  //     console.log("valueyyyyyyyyyyyy", this.state.value);

  //     let value = this.props.chemistOrderDtls;

  //     this.props.EditItemDetails(value);

  //     this.props.close();
  //     this.props.resetPage();
  //   };
  //   reject = () => {
  //     let value = this.props.ordersToShow;
  //     console.log("valueyyyyyyyyyyyy", this.state.value);
  //     this.props.ordersInActive(value);
  //     this.props.close();
  //     this.props.resetPage();
  //   };

  render() {
    console.log(this.props.orderToShow);

    const data =
      this.props.ordersToShow && this.props.ordersToShow.item
        ? this.props.ordersToShow && this.props.ordersToShow.item
        : null;

    const items = this.props.chemistOrderDtls
      ? this.props.chemistOrderDtls
      : null;

    const count =
      this.props.chemistOrderDtlsCount && this.props.chemistOrderDtlsCount;

    let p = this.state.page + 1;
    let OrdersViewpageCount = Math.ceil(count / this.state.perPage);
    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            size="lg"
            backdrop="static"
            className="Modalmodelboxdesigns"
            // style={{ backgroundColor: "rgba(0, 0, 0, 0.54)" }}
          >
            <Modal.Header
              style={{
                fontSize: '35px',
                backgroundColor: '#1768B7',
                color: 'white',
              }}
              closeButton
            >
              <Modal.Title>
                {/* <span style={{fontSize: '20px'}}>Urgent Order Details</span> */}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div className="chemistdetails">
                    <p className="chemistdetailspera">
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + ' ' + data.orderFrom.lName
                        : null}
                    </p>
                    <p className="chemistdetailspera">
                      {' '}{data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.mobileNo
                        : null}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.email
                        : null}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.addr},{' '}
                      {data !== null && data.pincode}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={4} lg={4} />
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p className="chemistdetailspera">
                      {' '}{data !== null && data.orderNo}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.orderFromName}
                    </p>
                    {/* <p className="chemistdetailspera">
                      {data !== null && data.landMark}
                    </p> */}
                    <p className="chemistdetailspera">
                      {data !== null && data.city}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, 'dd-mmm-yyyy')
                        : null}
                    </p>
                  </div>
                </Col>
              </Row>
              <div className="coomonlinebody">
                <hr />
              </div>

              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h3 className="itemdetailshd">Item Details</h3>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3} />

                <Col xs={12} sm={12} md={3} lg={3} />
                <Col xs={12} sm={12} md={3} lg={3}>
                  <div>
                    <i className="cui-note icons cmnRecordIcon" />
                    <span className="cmnPageCount">
                      {' '}{count !== undefined ? count : 0}
                    </span>
                    <span className="cmnResutText">Items</span>
                  </div>
                </Col>
              </Row>
              <Card.Body>
                <div className="viewnormaltablecommon">
                  <Table className="dashTable">
                    <thead className="tablecommonclr">
                      <tr>
                        <th>#</th>
                        <th>Item Code</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Unit </th>
                        {/* <th>Unit Price</th>
                        <th>Total</th> */}
                        <th>Availability</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody className="tablecommonclrtbody">
                      {this.props.chemistOrderDtls &&
                        this.props.chemistOrderDtls.map((item, i) =>
                          <tr key={i}>
                            <th scope="row">
                              {i + 1}
                            </th>
                            <td className="cmn_Cap">
                              {item !== null &&
                                item.itemCode !== null &&
                                item.itemCode !== undefined &&
                                item.itemCode.drugCode}
                            </td>
                            <td className="cmn_Cap">
                              {item !== null && item.itemName}
                            </td>
                            <td className="cmn_Cap">
                              {item !== null && item.avlblQntty}
                            </td>
                            <td className="cmn_Cap">
                              {item !== null &&
                                item.unitType !== null &&
                                item.unitType !== undefined &&
                                item.unitType.name}
                            </td>

                            <td className="cmn_Cap">
                              {item !== null && item.avlble == true
                                ? 'Available'
                                : 'Not Available'}
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </Table>
                  {(this.props.chemistOrderDtls === undefined ||
                    (this.props.chemistOrderDtls &&
                      this.props.chemistOrderDtls.length === 0)) &&
                    <div>
                      <div className="noDataImgDiv">
                        <Image
                          className="noDataImg"
                          src={require('../../assets/img/nodata4.png')}
                        />
                      </div>
                      <div className="noDataTextDiv">No Items Found</div>
                    </div>}
                </div>
              </Card.Body>

              {OrdersViewpageCount > 1
                ? <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={this.state.page}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={OrdersViewpageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination flex-wrap'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  </div>
                : null}
              {/* </Card> */}

              {/* <div className="itembtn">
                <Button className="queryBtn" onClick={this.Submit}>
                  Accept
                </Button>
              </div> */}
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#1768B7'}}>
              {/* <Button className="queryBtn" onClick={this.reject}>
                Reject
              </Button>
              <Button className="queryBtn" onClick={this.Submit}>
                Accept
              </Button> */}
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ViewOrders;
